

import Nav from './nav';
import Main from './homeSrc.js/main';
import '../stylesheets/home.css';
import ChangeTittle from './titilechanger';
function Home(){
    ChangeTittle();
    return(
        <div>
            <Nav/>
            <div className='Hero'>
                <Main/>
                <div className='heroImg'>
                    <img src={require('../sources/hero.jpg')} alt='hero'/>
                </div>
            </div>
        </div>
    );
}

export default Home;